import { render } from "./ycmx.vue?vue&type=template&id=6280ea5b&scoped=true&ts=true"
import script from "./ycmx.vue?vue&type=script&lang=ts"
export * from "./ycmx.vue?vue&type=script&lang=ts"

import "./ycmx.vue?vue&type=style&index=0&id=6280ea5b&lang=less&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6280ea5b"]])

export default __exports__